export const UsersMessages = {
    usersMessages: {
        TITLE_LIST: 'Listado Usuarios',
        TITLE_NEW: 'Creación Usuario',
        MESSAGE_NEW: 'El usuario fue creado exitosamente',
        'USER-NEW-FAIL': 'Se presento un error al crear el usuario',
        TITLE_EDIT: 'Edición Usuario',
        MESSAGE_EDIT: 'El usuario fue actualizado exitosamente',
        'USER-EDIT-FAIL': 'Se presento un error al actualizar el usuario',
        'USER-FAIL-CODE': 'El código del usuario ya existe',
        'USER-FAIL-EMAIL': 'El correo del usuario ya existe',
        TITLE_INACTIVE: 'Deshabilitar Usuario',
        MESSAGE_INACTIVE: 'Está seguro que desea deshabilitar el usuario',
        TITLE_REACTIVATE: 'Habilitar Usuario',
        MESSAGE_REACTIVATE: 'Está seguro que desea habilitar el usuario',
        MESSAGE_INACTIVE_OK: 'Se deshabilito el usuario exitosamente',
        MESSAGE_REACTIVATE_OK: 'Se habilito el usuario exitosamente',
        'USER-INACTIVE-FAIL': 'Se presento un error al deshabilitar el usuario',
        USER_NOT_FOUND: 'No se encontro el usuario',
        PASSWORD_UPDATE_FORBIDDEN:
            'El usuario no tiene permisos para actualizar la contraseña',
    },
};
